export default class Spinner {
  constructor({ main, opts }) {
    this._ = main;
    const { MapboxMap } = opts;
    this.map = MapboxMap;
    this.initSpinner();
  }

  initSpinner() {
    const spinnerBg = this._.el.querySelector("#".concat("spinner-background"));
    if (spinnerBg) this.spinnerEl = spinnerBg;
    else {
      const spinnerBgEl = document.createElement("div");
      spinnerBgEl.setAttribute("id", "spinner-background");

      const spinnerEl = document.createElement("div");
      spinnerEl.classList.add("spinner-container");

      const spinner = document.createElement("div");
      spinner.classList.add("spinner");

      spinnerEl.appendChild(spinner);
      spinnerBgEl.appendChild(spinnerEl);
      this._.el.append(spinnerBgEl);
      this.spinnerEl = spinnerBgEl;
    }
  }

  stopSpinner(e) {
    if (e.target && e.target.loaded()) {
      this.loadingSpinner(false);
      this.map.mapboxmap.off("render", this.stopSpinner);
    }
  }

  loadingSpinner(on) {
    if (on) {
      this.spinnerEl.classList.add("loading");
    } else {
      this.spinnerEl.classList.remove("loading");
    }
  }
}
